import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AppRoutes } from '../constants/routes.const';
import { canAccessApp, canAccessTimeTrackingModule } from '../utils/permissions.utils';

export const guestGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return toObservable(authService.isAuthReady).pipe(
    filter(ready => ready),
    take(1),
    map(() => {
      const user = authService.currentUser();
      if (user) {
        const redirectUrl = route.queryParams['redirect'];
        if (redirectUrl) {
          return router.parseUrl(redirectUrl);
        }
        const claims = authService.userClaims();
        if (canAccessApp(claims)) {
          return router.parseUrl(AppRoutes.Dashboard.Root);
        }
        if (canAccessTimeTrackingModule(claims)) {
          return router.parseUrl(AppRoutes.ControleDeHoras.Root);
        }
        return router.parseUrl(AppRoutes.Dashboard.Root);
      }
      return true;
    })
  );
};
